import {
    useEffect,
    useRef
} from "react";

/* Runs callback when variables change EXCLUDING the initial load that useEffect normally has */

const useEffectWithoutLoad = (callback, varArray = []) => {

    const hasLoaded = useRef(false);

    useEffect(() => {

        if (hasLoaded.current) {
            callback();
        } else {
            hasLoaded.current = true;
        }

    }, varArray);
}

export default useEffectWithoutLoad;